/* vue */
import Vue from 'vue';
/* vue-router */
import VueRouter from 'vue-router';
/* axios */
import axios from "axios";
/* moment */
import moment from "moment";
/* luxon */
import { DateTime } from "luxon";
/* router */
import clientRouter from './components/routers/clientRouters';
/* vue-google-maps */
import * as VueGoogleMaps from "vue2-google-maps";
/* v-model */
import VModal from "vue-js-modal";
// material icons
import 'material-icons/iconfont/filled.css';
import 'material-icons/iconfont/outlined.css';
// material symbols (font-400)
import '@material-symbols/font-400/outlined.css';
/* font-awesome-icon-6 */
import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faAlignCenter, faAlignJustify, faAlignLeft, faAlignRight, faAngleDoubleLeft, faAngleDown, faAngleLeft, faAngleRight, faArrowDown, faArrowUp, 
    faAt, faBars, faBold, faBolt, faCaretDown, faCaretRight, faChartBar, faChartColumn, faChartLine, faChartPie, faChartSimple, faCheck, 
    faCheckCircle, faChevronDown, faChevronRight, faCircle, faCircleDot, faClockRotateLeft, faCloudDownloadAlt, faCloudUploadAlt, faCode, faCog, 
    faCompress, faCompressAlt, faDesktop, faDownload, faEdit, faEllipsisH, faEllipsisV, faExclamationCircle, faExclamationTriangle, faExpand, 
    faExpandAlt, faFastForward, faFileDownload, faFileUpload, faForward, faGripVertical, faIndent, faInfo, faInfoCircle, faItalic, faKey, faLaptop, 
    faLink, faListOl, faListUl, faLock, faMapMarkedAlt, faMinus, faMinusCircle, faMobileAlt, faOutdent, faPaperclip, faParagraph, faPaste, faPause, 
    faPen, faPenRuler, faPhone, faPlay, faPlus, faPrint, faProjectDiagram, faRedoAlt, faRightLeft, faRightLong, faScroll, faSearch, faServer, 
    faShareAlt, faShareFromSquare, faShoppingBag, faSignOutAlt, faSpinner, faStar, faStepForward, faStop, faStrikethrough, faSubscript, 
    faSuperscript, faSyncAlt, faTable, faTasks, faThumbtack, faTimes, faTimesCircle, faTrash, faUnderline, faUnlink, faUnlock, faUpRightFromSquare, 
    faUser, faUserCheck, faUserFriends, faUserPlus, faUserTag, faUserTimes, faUsers, faWandMagicSparkles, faWandSparkles, faCamera, faTableCellsLarge,
    faLocationCrosshairs, faTabletScreenButton, faHandPointRight, faCouch, faExclamation, faFilter, faArrowPointer, faFile, faSquareMinus, faSquareCheck, 
    faSquare, faFont, faImage, faBorderNone, faArrowsUpToLine, faArrowsDownToLine, faMoon, faQuoteLeft, faPencil, faCaretUp, faSort,
    faSortUp, faSortDown, faLightbulb, faGraduationCap, faClock, faFileAlt, faPlug, faBan, faPuzzlePiece
} from '@fortawesome/free-solid-svg-icons';
import {
    faSlack as fabSlack, faWhatsapp as fabWhatsapp, faDiscord as fabDiscord, faTwitter as fabTwitter,
} from '@fortawesome/free-brands-svg-icons'
import {
    faTrashAlt as farTrashAlt, faFile as farFile, faFileAlt as farFileAlt,
    faEye as farEye, faEyeSlash as farEyeSlash, faEnvelope as farEnvelope, faCalendar as farCalendar, faCommentAlt as farCommentAlt,
    faCheckCircle as farCheckCircle, faTimesCircle as farTimesCircle, faBell as farBell,
    faStar as farStar, faCircle as farCircle, faFileCode as farFileCode, faFilePdf as farFilePdf, faUser as farUser, faEdit as farEdit,
    faComment as farComment, faPaperPlane as farPaperPlane, faCalendarPlus as farCalendarPlus, faClipboard as farClipboard,
    faQuestionCircle as farQuestionCircle, faPlusSquare as farPlusSquare, faPlayCircle as farPlayCircle, faClone as farClone,
    faShareFromSquare as farShareFromSquare, faCheckSquare as farCheckSquare, faWindowMaximize as farWindowMaximize, faWindowRestore as farWindowRestore,
    faBuilding as farBuilding, faHourglass as farHourglass
} from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome';
/* toasted */
import Toasted from 'vue-toasted';
/* vue-tippy */
import VueTippy, { TippyComponent } from "vue-tippy";
Vue.use(VueTippy);
Vue.component("tippy", TippyComponent);
/* vue-meta */
import VueMeta from 'vue-meta';
Vue.use(VueMeta);
/* vue-cookies */
import VueCookies from 'vue-cookies'
Vue.use(VueCookies);
/* firebase */
import firebase from "firebase/app";
import "firebase/messaging";
import "firebase/analytics";
/* auth */
import { authorizationStore } from './components/store/authorizationStore';
import { settingsStageAllowed, settingsRedirectFor } from "./components/settings/settingsStage";
import { rememberPortalReturn } from "./components/portals/portalReturn";
import commons from "./components/commons/commons";
/* x-routing telemetry */
import { setFallbackReporter } from './components/store/xClient';
/* scss */
import "./assets/scss/fonts.scss";
import "./assets/scss/fts-style.scss";
import "./assets/scss/fts-utilities.scss";
import "./assets/scss/fts-components.scss";
import "./assets/scss/fts-theme.scss";
import "./assets/scss/fts-flags.scss";
import "./assets/scss/global.scss";
// after the theme and token sheets: a person's Reading preference overrides them (FTR00375)
import "./assets/scss/fts-readability.scss";
import "./assets/scss/components/toasted-alert.scss";
import "./assets/scss/material-symbols.scss";
/* css */
import 'vue-swatches/dist/vue-swatches.css';
import { clientStore } from './components/store/clientStore';
import webAppConfig from './components/commons/webApp.config';
/* components */
import { DeviceName } from './components/commons/enum';
import FTSReleaseBadge from './components/elements/FTSReleaseBadge';
import LocalStorageService from './components/store/LocalStorageService';
import { RuntimeLoader } from "@rive-app/webgl2";
RuntimeLoader.setWasmUrl("./pi/rive/rive.wasm");
Vue.component('fts-release-badge', FTSReleaseBadge);
/* google maps */
Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyBxXR_1K5DzIeWdi7Fc7ocbR0UVqP1P7_0",
        libraries: "places" // necessary for places input
    }
});
/* v-modal */
Vue.use(VModal, { dialog: true, dynamic: true, injectModalsContainer: true })
/* font-awesome-icon-6 */
library.add(
    faAngleDoubleLeft, faAngleDown, faAngleLeft, faAngleRight, faArrowDown, faArrowUp, faAt, faBars, faBolt, faCaretDown, faCaretRight, faChartBar, 
    faChartColumn, faChartLine, faChartPie, faChartSimple, faCheck, faCheckCircle, faChevronDown, faChevronRight, faCircle, faCircleDot, faClockRotateLeft, 
    faCloudDownloadAlt, faCloudUploadAlt, faCode, faCog, faCompress, faCompressAlt, faDesktop, faDownload, faEdit, faEllipsisH, faEllipsisV, faExclamationCircle, 
    faExclamationTriangle, faExpand, faExpandAlt, faFastForward, faFileDownload, faFileUpload, faForward, faGripVertical, faInfo, faInfoCircle, faKey, faLaptop, 
    faLock, faMapMarkedAlt, faMinus, faMinusCircle, faMobileAlt, faPaperclip, faPaste, faPause, faPen, faPenRuler, faPhone, faPlay, faPlay, faPlus, faPrint, 
    faProjectDiagram, faRedoAlt, faRightLeft, faRightLong, faScroll, faSearch, faServer, faShareAlt, faShareFromSquare, faShoppingBag, faSignOutAlt, faSpinner, 
    faStar, faStepForward, faStop, faSyncAlt, faTable, faTasks, faThumbtack, faTimes, faTimesCircle, faTrash, faUnlock, faUpRightFromSquare, faUser, faUserCheck,
    faUserFriends, faUserPlus, faUserTag, faUserTimes, faUsers, faWandMagicSparkles, faWandSparkles, faCamera, faTableCellsLarge, faLocationCrosshairs, faTabletScreenButton,
    faHandPointRight, faCouch, faExclamation, faFilter, faArrowPointer, faFile, faSquareMinus, faSquareCheck, faSquare, faFont, faImage, faBorderNone, faArrowsUpToLine,
    faArrowsDownToLine, faMoon, faQuoteLeft, faPencil, faCaretUp, faSort, faSortUp, faSortDown, faLightbulb, faGraduationCap, faClock, faFileAlt,
    faPlug, faBan, faPuzzlePiece
)
/* brand icon */
library.add(fabWhatsapp, fabSlack, fabDiscord, fabTwitter)
/* regular icon */
library.add(
    farTrashAlt, farFile, farFileAlt, farEye, farEyeSlash, farEnvelope, farCalendar, farCommentAlt, farCheckCircle, farTimesCircle, 
    farStar, farFileCode, farFilePdf, farUser, farEdit, farComment, farPaperPlane, farCalendarPlus, farClipboard,farQuestionCircle, 
    farPlusSquare, farClone, farShareFromSquare, farCheckSquare, farWindowMaximize, farWindowRestore, farHourglass
)
/* editor icon */
library.add(
    faBold, faItalic, faStrikethrough, faIndent, faOutdent, faParagraph, faUnderline, faListUl, faListOl,
    faLink, faUnlink, faAlignLeft, faAlignCenter, faAlignRight, faAlignJustify, faSuperscript, faSubscript, farBell, farCircle,
    farPlayCircle, farBuilding
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)
/* toasted (due to some reason so need to use window.addEventListener) */
window.addEventListener('load', () => {
    Vue.use(Toasted, {
        theme: "toasted-primary",
        position: 'top-center',
        duration: 5000
    });
    // success
    Vue.toasted.register('success', (payload) => {
        return payload.message || "Submission successful"
    }, { type: 'success' });
    // error
    Vue.toasted.register('error', (error = {}, message) => {
        if (error.code === "ECONNABORTED") {
            return "Request timed out. Please check your network connection and try again.";
        } else if (
            error.message && (
                error.message.includes("Network Error") || 
                error.message.includes("ERR_NETWORK")
            )
        ) {
            return "No internet connection. Please check your internet connection and try again";
        } else if (
            error.response && 
            error.response.data && 
            error.response.data.message
        ) {
            return error.response.data.message;
        } else if (error.message) {
            return error.message;
        } else if (message) { // fallback message
            return message;
        }
        return "Something went wrong";
    }, { type: 'error' });
    // warn
    Vue.toasted.register('warn', (payload) => {
        return payload.message || 'Something went wrong';
    }, { type: 'error', className: ['toasted--warn'] });
    // invalid form validate
    Vue.toasted.register('invalidFormValidate', (payload) => {
        return payload.message || "Please ensure all values are in a proper format"
    }, { type: 'error' });
    // unauthorized
    Vue.toasted.register('unauthorized', (payload) => {
        return payload.message || "Unauthorized access. You do not have permission to access this. Please contact your system administrator for assistance."
    }, { type: 'error' });
    // success:lite
    Vue.prototype.$alertSuccess = (message = "Successful", options = {}) => {
        const {
            disableIcon = false,
            disableAction = false,
            icon = "check_circle",
            iconPack = "material-icons",
            position = "top-center",
            duration = 5000,
            closeOnSwipe = true
        } = options;

        let toastOptions = {
            theme: "outline",
            position,
            duration,
            closeOnSwipe,
            className: "toasted--lite toasted--success",
        }
        // close button
        if (!disableAction) {
            toastOptions.action = {
                text: '✕',
                onClick: (e, toastObject) => {
                    toastObject.goAway(0);
                }
            };
        }
        // icon
        if (!disableIcon) {
            toastOptions.iconPack = "callback";
            toastOptions.icon = () => {
                const span = document.createElement('span');
                span.className = `${iconPack} toasted-icon`;
                span.innerText = icon;
                return span;
            };
        }

        Vue.toasted.show(message, toastOptions);
    }
    Vue.prototype.$alertError = (message = "Something went wrong", options = {}) => {
        const {
            disableIcon = false,
            disableAction = false,
            icon = "error",
            iconPack = "material-icons",
            position = "top-center",
            duration = 5000,
            closeOnSwipe = true
        } = options;

        let toastOptions = {
            theme: "outline",
            position,
            duration,
            closeOnSwipe,
            className: "toasted--lite toasted--danger",
        }
        // close button
        if (!disableAction) {
            toastOptions.action = {
                text: '✕',
                onClick: (e, toastObject) => {
                    toastObject.goAway(0);
                }
            };
        }
        // icon
        if (!disableIcon) {
            toastOptions.iconPack = "callback";
            toastOptions.icon = () => {
                const span = document.createElement('span');
                span.className = `${iconPack} toasted-icon`;
                span.innerText = icon;
                return span;
            };
        }

        Vue.toasted.show(message, toastOptions);
    }
});
/* window */
window.appConfig = appConfig;
window.moment = moment;
window.luxon = DateTime;
window.axios = axios;
/* event bus */
window.eventBus = new Vue();
window.createBus = function () {
    return eventBus;
}
/* run app */
window.runClientApp = function () {
    /* firebase */
    var firebaseConfig = {
        apiKey: "AIzaSyBxXR_1K5DzIeWdi7Fc7ocbR0UVqP1P7_0",
        authDomain: "fetias-01.firebaseapp.com",
        databaseURL: "https://fetias-01.firebaseio.com",
        projectId: "fetias-01",
        storageBucket: "fetias-01.appspot.com",
        messagingSenderId: "664109851190",
        appId: "1:664109851190:web:7502530893af71eb382e97",
        measurementId: "G-H6XT3P234F",
    };
    firebase.initializeApp(firebaseConfig);
    const analytics = firebase.analytics();
    /* x-routing: report every /x 501-fallback (and stranded-fallback) to the real analytics sink */
    setFallbackReporter(({ endpoint, stage }) => {
        analytics.logEvent('x_fallback', { key: endpoint, reason: stage });
    });
    /* fcm */
    try {
        let messaging = firebase.messaging();
        messaging.onMessage((payload) => {
            console.log('FCM Message received. ', payload);
            window.eventBus.$emit('notification', payload);
        });

        messaging
            .requestPermission()
            .then(function () {
                console.log("Notification permission granted.");
                return messaging.getToken();
            })
            .then(function (token) {
            })
            .catch(function (err) {
                console.log("Unable to get permission to notify.", err);
            });
    } catch (ex) {
        console.warn("fcm error", ex);
    }
    /* router */
    const router = new VueRouter({
        routes: clientRouter,
    });
    router.beforeEach(async (to, from, next) => {
        let toQuery = { ...to.query };

        // Admin SSO: the return target can arrive in the hash query (#/login?sso_return_uri=…) or,
        // when the admin SPA links to the bare origin, in the server query string — which the hash
        // router ignores, so the user would just land on dashboard. Normalize it onto the /login
        // route so FTSLogin runs the handoff (for both already-logged-in and fresh-login cases).
        const ssoReturnUri = to.query.sso_return_uri
            || new URLSearchParams(window.location.search).get('sso_return_uri');
        if (ssoReturnUri && to.name !== 'login') {
            next({ name: 'login', query: { ...to.query, sso_return_uri: ssoReturnUri } });
            return;
        }

        if (to.query.solutionId) {
            let response = await authorizationStore.dispatch("getDemoAuthCode", to.query.solutionId);
            if (response.data.authCode) {
                await authorizationStore.dispatch("refreshToken", response.data.authCode);
                let wsId = response.data.wsId;
                
                // $cookies.set('wsId', 'demo:' + wsId + response.data.demoId);
                $cookies.set('wsId', wsId);
                LocalStorageService.setWorkspaceId(webAppConfig.baseServer, wsId);

                if (clientStore.getters.workspaceId && clientStore.getters.workspaceId != wsId) {
                    await clientStore.dispatch("loadWorkspace", {
                        id: wsId,
                        client: true
                    });
                }
            }
        } else if (to.query.accessToken && to.query.refreshToken) {
            delete toQuery.accessToken;
            delete toQuery.refreshToken;
            authorizationStore.dispatch('setAuth', { 'access_token': to.query.accessToken, 'refresh_token': to.query.refreshToken });
            await authorizationStore.dispatch("refreshToken");

            if (to.query.wsId) {
                $cookies.set('wsId', to.query.wsId);
                LocalStorageService.setWorkspaceId(webAppConfig.baseServer, to.query.wsId);

                if (clientStore.getters.workspaceId && clientStore.getters.workspaceId != to.query.wsId) {
                    await clientStore.dispatch("loadWorkspace", {
                        id: to.query.wsId,
                        client: true
                    });
                }

                delete toQuery.wsId;
            }
        }

        if (to.query.source) {
            delete toQuery.source;
            if (to.query.source === DeviceName.WEBAPP) {
                const lsWebData = LocalStorageService.getWebData(webAppConfig.baseServer);
                LocalStorageService.setWebData(webAppConfig.baseServer, {...lsWebData, prefDevice: DeviceName.WEB});
            }
        }

        const hasAuth = !!localStorage.getItem('ls.authorizationData');
        // P4 (W-3): /users and /connections folded into settings at GA. Builder sessions keep
        // the old pages, as they keep the old dialogs.
        const folded = !commons.builderMode && settingsRedirectFor(to.name);

        if (to.matched.some(x => x.meta.requiresAuth) && !hasAuth) {
            // A portal link opened while signed out comes back to the portal after the login page,
            // not to the dashboard (FTSLogin.redirect takes it). This route only.
            if (to.name === 'portal') rememberPortalReturn(to.params.id);
            next({ name: 'logout' });
        } else if (folded) {
            next(folded);
        } else if (to.matched.some(x => x.meta.requiresInternal) && !authorizationStore.getters.isInternal) {
            next({ name: 'dashboard' });
        } else if (to.matched.some(x => x.meta.requiresStage === 'settings') && !settingsStageAllowed()) {
            // W-25: outside the settings area's release stage (since GA, only the kill switch
            // does that). Land on the workspace -- never a 404, never a blank page -- with the
            // old dialog back in the menu.
            next({ name: 'dashboard' });
        } else if (to.name === 'login' && hasAuth && !(to.query.mcp_nonce && to.query.mcp_callback) && !to.query.sso_return_uri) {
            next({ name: 'dashboard' });
        } else if (JSON.stringify(toQuery) !== JSON.stringify(to.query)) {
            next({ ...to, query: toQuery });
        } else {
            next();
        }
    });
    /* window:router */
    window.router = router;
    /* vue */
    new Vue({
        el: '#client',
        router: router,
        render: h => h({
            template: '<router-view />'
        }),
    });
}